import { Pipe, PipeTransform } from '@angular/core';



const lookup = {
  0: 'Eve User',
  1: 'IVR',
  2: 'Hunt Group',
  3: 'Call Queue',
  4: 'Sip Trunk',
  5: 'Group Voicemail',
  6: 'Teams Trunk',
  7: 'Group Pickup',
  8: 'Voicemail Retrieval',
  9: 'Group Voicemail Retrieval'
};



@Pipe({
  name: 'billingIdToOwnerType'
})
export class BillingIdToOwnerTypePipe implements PipeTransform {
  transform(value: string): any {
    
    return lookup[value.charAt(15)];
  }
}

